// extracted by mini-css-extract-plugin
export var tableContainer = "styles-module--table-container--c9e3c";
export var tableItem = "styles-module--table-item--0c6bd";